<template>
  <div>
    <g-breadcrumb :paginas="paginaStatus.caminhoMigalha" />
    <!-- <form
      @submit.prevent="salvar"
      style="margin-top:25px;"
      enctype="multipart/form-data"
    > -->
    <div class="q-card gvn-cabecalho">
      <div class="row">
        <div class="col-10 gvn-title-primary mrg-t-0">Dados do requerente</div>
        <div
          class="col-sm-2 text-right"
        >
          <q-tooltip v-if="imprimir == true">Comprovante de encaminhamento</q-tooltip>
          <q-btn
            id="imprimirComprovanteEncaminhamento"
            name="imprimirComprovanteEncaminhamento"
            icon="fa fa-print"
            v-if="imprimir == true"
            color="primary"
            @click="imprimirComprovanteEncaminhamento"
            flat
          >&ensp;&ensp;Imprimir
          </q-btn>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>Tipo de Pessoa:: </strong>
          {{ this.indTipoPessoa === 'J' ? 'Jurídica' : 'Física' }}
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>Nome: </strong>
          {{this.nomRequerente}} - {{this.txtDocumento}}
        </div>
        <div
          class="col-lg-3 col-md-3 col-sm-12 col-xs-12"
          v-if="indTipoPessoa !== 'J'"
        >
          <strong>Data de nascimento: </strong>
          {{this.formatarData(this.dataNascimento, 'dd/mm/yyyy')}}
        </div>
      </div>
      <div
        class="row"
        v-if="indTipoPessoa !== 'J'"
      >
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>Sexo: </strong>
          {{this.indSexo === 'M' ? 'Masculino' : this.indSexo === 'F' ? 'Feminino' :  this.indSexo === 'I' ? 'Indiferente' : ''}}
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>Estado Civil: </strong>
          {{this.formataEstadoCivil(this.indEstadoCivil)}}
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>Nacionalidade: </strong>
          {{this.nomNacionalidade}}
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>CEP: </strong>
          {{this.numCEP}}
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>Logradouro: </strong>
          {{this.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.requerente.logradouro.nomLogradouro}}
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>Número: </strong>
          {{this.numNumero}}
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>Complemento: </strong>
          {{this.txtComplemento}}
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>Bairro: </strong>
          {{this.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.requerente.bairro.nomBairro}}
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>Cidade: </strong>
          {{this.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.requerente.municipio.nomMunicipio}}
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>UF: </strong>
          {{this.desUf}}
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>Telefone Móvel: </strong>
          {{this.numTelefoneMovelPortal || this.numTelefoneMovel}}
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <strong>Email: </strong>
          {{this.txtEmailPortal || this.txtEmail}}
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <strong>Telefone Residencial: </strong>
          {{this.numTelefoneResidencialPortal || this.numTelefoneResidencial}}
        </div>
      </div>
    </div>
    <br />
    <g-gridview
      id="refSolicitacaoMovimentacaoDocumentos"
      name="refSolicitacaoMovimentacaoDocumentos"
      ref="refSolicitacaoMovimentacaoDocumentos"
      :exibirEtiqueta="false"
      :colunas="colunasSolicitacaoDocumentosDataTable"
      :operacoes="operacoes"
      :exibirBotaoVisualizacao="false"
      :exibirBotaoEdicao="false"
      :exibirBotaoExclusao="false"
      :desabilitar="true"
      :exibirColunaOperacoes="exibirColunaOperacoes"
      :inicializarVazio="true"
    >
      <div class="row">
        <div class="col-12 gvn-title-primary mrg-t-0">Dados da solicitação</div>
      </div>

      <div class="row">
        <div class="col-sm-3 col-xs-3 mrg-t-10">
          <g-input
            id="refNumSolicitacao"
            name="refNumSolicitacao"
            ref="refNumSolicitacao"
            tipo="text"
            etiqueta="Nº Solicitação"
            validacao="numeric"
            :foco="false"
            :desabilitar="true"
            v-model="paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.numSolicitacao"
          >
          </g-input>
        </div>
        <div class="col-sm-3 col-xs-3">
          <g-datepicker
            id="refDatSolicitacao"
            name="refDatSolicitacao"
            ref="refDatSolicitacao"
            etiqueta="Data Solicitação"
            :desabilitar="true"
            v-model="paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.datSolicitacao"
          >
          </g-datepicker>
        </div>
        <div class="col-sm-5 col-xs-5 mrg-l-48 mrg-t-10">
          <g-autocomplete
            id="refTipoProcesso"
            name="refTipoProcesso"
            ref="refTipoProcesso"
            etiqueta="Tipo de Processo"
            valor="codTipoProcesso"
            :foco="false"
            descricaoPrimaria="desTipoProcesso"
            :api="apitipoProcesso"
            :desabilitar="desabilitarTipoProcesso"
            v-model="codTipoProcesso"
          ></g-autocomplete>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 col-xs-6">
          <g-autocomplete
            id="refAssunto"
            name="refAssunto"
            ref="refAssunto"
            etiqueta="Assunto"
            valor="codAssunto"
            descricaoPrimaria="desAssunto"
            :foco="false"
            :api=apiAssunto
            :desabilitar="desabilitarAssunto"
            v-model="codAssunto"
          >
          </g-autocomplete>
        </div>
        <div class="col-sm-6 col-xs-6">
          <g-autocomplete
            id="refSubAssunto"
            name="refSubAssunto"
            ref="refSubAssunto"
            etiqueta="Subassunto"
            valor="codSubassunto"
            descricaoPrimaria="desSubassunto"
            :acaoPosSelecao="buscarDocumentoNecessario"
            :api=apiSubAssunto
            :foco="false"
            :filtroAdicional="getFiltroSubassunto"
            :desabilitar="codAssunto == null || codAssunto == '' || desabilitarSubAssunto"
            v-model="codSubassunto"
          >
          </g-autocomplete>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-xs-12">
          <g-autocomplete
            id="refJustificativa"
            name="refJustificativa"
            ref="refJustificativa"
            etiqueta="Justificativa do Processo"
            valor="codJustificativa"
            :foco="false"
            descricaoPrimaria="desJustificativa"
            :desabilitar="!codTipoProcesso || !codAssunto || !codSubassunto"
            :api="apiJustificativa"
            :filtroAdicional="getFiltroJustificativa"
            v-model="paginaStatus.aberturaProcesso.justificativa.codJustificativa"
          ></g-autocomplete>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-xs-12">
          <g-input
            id="refJustificativaSolicitacao"
            name="refJustificativaSolicitacao"
            ref="refJustificativaSolicitacao"
            tipo="textarea"
            etiqueta="Descrição"
            validacao="maxlength(1000)"
            :tamanho="1000"
            :foco="false"
            :desabilitar="desabilitarObservacao"
            v-model="txtJustificativa"
          >
          </g-input>
        </div>
        <div class="col-sm-12 col-xs-12">
          <g-input
            id="refObservacaoSolicitacao"
            name="refObservacaoSolicitacao"
            ref="refObservacaoSolicitacao"
            tipo="textarea"
            etiqueta="Observação da Solicitação"
            validacao="maxlength(250)"
            :tamanho="250"
            :foco="false"
            :desabilitar="desabilitarObservacao"
            v-model="txtObservacao"
          >
          </g-input>
        </div>
      </div>
      <div class="row">
        <div class="col-12 gvn-title-primary mrg-t-2">Documentação Anexada</div>
      </div>
    </g-gridview>
    <div class="q-card gvn-cabecalho mrg-b-10">
      <div class="row">
        <div class="col-12 gvn-title-primary mrg-t-2">Documentação Necessária</div>
      </div>
      <div class="row">
        <table
          class="col-md-12"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th
                class="text-left"
                width="50%"
              >Documentação Necessária Entregue</th>
            </tr>
          </thead>
          <!--{{documentoToggle}}-->
          <tbody>
            <tr
              v-for="doc in dadosDocumentoNecessarioArray"
              v-bind:key="doc.a"
            >
              <td class="text-left">
                <q-toggle
                  id="toglleDesabilidarDocumentos"
                  name="toglleDesabilidarDocumentos"
                  :disable="desabilitarDocumentos"
                  v-model="documentoToggle"
                  color="teal-8"
                  :val="doc"
                  true-value="S"
                  false-value="N"
                  checked-icon="check"
                  unchecked-icon="clear"
                />
                &ensp;&ensp;
                {{doc.documento.nomDocumento}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="q-card gvn-cabecalho mrg-b-10">
      <div class="row">
        <div class="col-12 gvn-title-primary mrg-t-2">Retorno da Solicitação</div>
      </div>
      <div class="row">
        <div
          class="col-sm-3 col-xs-3"
          style="padding-top: 10px;"
        >
          <g-select
            id="refIndRetorno"
            name="refIndRetorno"
            ref="refIndRetorno"
            etiqueta="Retorno da Solicitação"
            :itens="retornoArray"
            item-valor="indRetorno"
            item-etiqueta="descricao"
            :foco="false"
            :desabilitar="desabilitarRetorno"
            v-model="indRetorno"
          >
          </g-select>
        </div>
      </div>
      <br />
      <div class="row">
        <div
          v-if="indRetorno === 'PDC' || indRetorno === 'REJ'"
          class="col-sm-12 col-xs-12"
        >
          <q-editor
            id="editortxtObservacaoRetorno"
            name="editortxtObservacaoRetorno"
            v-model="txtObservacaoRetorno"
            :readonly="readonly"
            :disable="desabilitarObservacaoRetorno"
            :toolbar="[
                ['bold', 'italic', 'strike', 'underline', 'subscript', 'superscript'],
                ['token', 'hr', 'link', 'custom_btn'],
                ['fullscreen'],
                [
                  {
                    label: $q.i18n.editor.formatting,
                    icon: $q.icon.editor.formatting,
                    list: 'no-icons',
                    options: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'code']
                  },
                  {
                    label: $q.i18n.editor.fontSize,
                    icon: $q.icon.editor.fontSize,
                    fixedLabel: true,
                    fixedIcon: true,
                    list: 'no-icons',
                    options: ['size-1', 'size-2', 'size-3', 'size-4', 'size-5', 'size-6', 'size-7']
                  },
                  {
                    label: $q.i18n.editor.defaultFont,
                    icon: $q.icon.editor.font,
                    fixedIcon: true,
                    list: 'no-icons',
                    options: ['default_font', 'arial', 'arial_black', 'comic_sans', 'courier_new', 'impact', 'lucida_grande', 'times_new_roman', 'verdana']
                  },
                  'removeFormat'
                ],
                ['quote', 'unordered', 'ordered', 'outdent', 'indent'],
                [
                  {
                    label: $q.i18n.editor.align,
                    icon: $q.icon.editor.align,
                    fixedLabel: true,
                    list: 'only-icons',
                    options: ['left', 'center', 'right', 'justify']
                  }
                ],
                ['undo', 'redo']
              ]"
            :fonts="{
                arial: 'Arial',
                arial_black: 'Arial Black',
                comic_sans: 'Comic Sans MS',
                courier_new: 'Courier New',
                impact: 'Impact',
                lucida_grande: 'Lucida Grande',
                times_new_roman: 'Times New Roman',
                verdana: 'Verdana'
              }"
          />
        </div>
      </div>
    </div>
    <!-- </form> -->
    <div class="col-12 text-right pad-20t-h10-80b">
      <q-btn
        round
        id="btnSalvar"
        name="btnSalvar"
        class="fixed"
        color="positive"
        icon="check"
        size="lg"
        @click="salvar"
        style="right: 18px; bottom:18px"
        v-show="visualizarSalvar"
      >
        <q-tooltip>Salvar</q-tooltip>
      </q-btn>
    </div>
  </div>
</template>

<script>
// IMPORT
import api from 'components/util/api'
import GDatatable from 'components/util/gDatatable'
import util from 'components/util/util'
import utilHttp from 'components/util/utilHttp'
import GInput from 'components/util/gInput'
import GGridview from 'components/util/gGridview'
import GBreadcrumb from 'components/util/gBreadcrumb'
import GDatepicker from 'components/util/gDatepicker'
import GAutocomplete from 'components/util/gAutocomplete'
import msg from 'components/util/msg'
import GSelect from 'components/util/gSelect'

export default {
  data () {
    return {
      chaveLocalStorage: 'solicitacaoAbertura',
      apitipoProcesso: api.TIPO_DE_PROCESSO_DESCRICAO,
      apiSubAssunto: api.SUB_ASSUNTO_COD_ASSUNTO,
      apiAssunto: api.ASSUNTO,
      apiNacionalidade: api.NACIONALIDADE,
      apiJustificativa: api.JUSTIFICATIVA_SUBASSUNTO,
      apiLogradouro: api.LOGRADOURO,
      apiCidade: api.CIDADE,
      apiBairro: api.BAIRRO,
      apiUf: api.BUSCAR_LISTA_UF,
      apiDownloadArquivo: api.PROTOCOLO_SOLICITACAO_MOVIMENTACAO_DOWNLOAD_ARQUIVO,
      apiDownloadArquivos: api.DOCUMENTO_ANEXO_PROCESSO_DOWNLOAD_ARQUIVOS,
      apiNotificacaoLida: api.NOTIFICACAO_SOLICITACAO_USUARIO_MARCAR_COMO_LIDA,
      apiImprimirRelatorio: api.RELATORIO_COMPROVANTE_ENCAMINHAMENTO,
      imprimir: false,
      desabilitarTipoProcesso: false,
      desabilitarAssunto: false,
      desabilitarSubAssunto: false,
      desabilitarRetorno: false,
      desabilitarRejeicao: true,
      desabilitarPendencia: true,
      desabilitarObservacao: true,
      desabilitarJustificativa: true,
      desabilitarResponsavel: true,
      visualizarSalvar: true,
      readonly: false,
      desabilitarDocumentos: false,
      desabilitarObservacaoRetorno: false,
      txtObservacaoRetorno: '',
      indTipoPessoa: '',
      indRetorno: '',
      txtComplemento: '',
      codUsuario: '',
      numCpf: '',
      numCnpj: '',
      numCEP: '',
      numNumero: '',
      codJustificativa: '',
      codResponsavel: '',
      nomRequerente: '',
      dataNascimento: '',
      cod: '',
      datSolicitacao: '',
      numSolicitacao: '',
      codNacionalidade: '',
      nomNacionalidade: '',
      codLogradouro: '',
      codBairro: '',
      codMunicipio: '',
      codUf: '',
      desUf: '',
      numTelefoneMovel: '',
      numTelefoneMovelPortal: '',
      numTelefoneResidencial: '',
      numTelefoneResidencialPortal: '',
      numTelefoneComercial: '',
      numTelefoneComercialPortal: '',
      txtEmail: '',
      txtEmailPortal: '',
      desObservacao: '',
      txtJustificativa: '',
      desRejeicao: '',
      desPendencia: '',
      txtDocumento: '',
      codTipoProcesso: '',
      codAssunto: '',
      codSubassunto: '',
      indSexo: '',
      indEstadoCivil: '',
      desabilitarCidade: true,
      desabilitarBairro: true,
      desabilitarDadosRequerente: true,
      desabilitarLogradouro: true,
      desabilitarUf: true,
      exibirColunaOperacoes: true,
      formaSolicitacaoWeb: '',
      pagina: 1,
      txtObservacao: '',
      elementosPorPagina: 10,
      dadosRoteiroArray: [],
      estadoCivilArray: [],
      sexoArray: [],
      retornoArray: [],
      ufArray: [],
      dadosDocumentoNecessarioArray: [],
      rotaArray: [],
      documentoToggle: [],
      paginaStatus: {
        aberturaProcesso: {
          formaSolicitacao: {},
          tipoProcesso: {},
          subassunto: {
            assunto: {}
          },
          roteiro: {
            setor: {
              unidade: {
                orgao: {}
              }
            }
          },
          requerente: {},
          representante: {},
          justificativa: {},
          responsavel: {},
          documentoNecessario: {},
          aberturaProcessoDocumento: {}
        },
        protocoloSolicitacaoMovimentacao: {
          protocoloSolicitacao: {
            codProcesso: '',
            tipoProcesso: {},
            subassunto: {
              assunto: {}
            },
            assuntoGeral: {},
            roteiro: { setor: { unidade: { orgao: {} } } },
            representante: {},
            justificativa: {},
            setor: { unidade: { orgao: {} } },
            responsavelMovimento: { usuario: {} },
            responsavel: { usuario: {} },
            requerente: {
              nacionalidade: { codNacionalidade: '', nomNacionalidade: '' },
              logradouro: { codLogradouro: '', nomLogradouro: '' },
              bairro: { codBairro: '', nomBairro: '' },
              municipio: { codMunicipio: '', nomMunicipio: '' },
              uf: { codUf: '', nomUf: '' }
            }
          }
        },
        desabilitarEdicao: false,
        caminhoMigalha: [
          {
            icone: '',
            descricao: '',
            rotaNome: ''
          }
        ]
      },
      colunasSolicitacaoDocumentosDataTable: [
        {
          conteudoTipo: '',
          largura: '60%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Arquivo',
          conteudoClasse: 'text-left',
          propriedade: 'servidorArquivo.nomeArquivo'
        }
      ],
      operacoes: [
        {
          cor: 'black',
          icone: 'fas fa-download',
          tooltip: 'Baixar Arquivo',
          clique: this.baixarAnexo,
          permissao: (row) => true,
          visivel: (row) => true
        },
        {
          cor: 'black',
          icone: 'fas fa-check-circle',
          tooltip: 'Confirmar Documento',
          clique: this.confirmarArquivo,
          permissao: (row) => !this.paginaStatus.desabilitarEdicao,
          visivel: (row) => this.habilitarConfirmarArquivo(row)
        }
      ]
    }
  },
  methods: {
    async buscarDocumentacaoApresentada () {
      var self = this
      return new Promise(resolve => {
        var filtro = ''
          .concat('?codTipoProcesso=')
          .concat(util.validarCampo(self.codTipoProcesso) ? self.codTipoProcesso : 0)
          .concat('&codAssunto=')
          .concat(self.codAssunto)
          .concat('&codSubassunto=')
          .concat(self.codSubassunto)

        utilHttp.httpGet(
          api.DOCUMENTACAO_NECESSARIA_TIPO_PROCESSO_E_ASSUNTO_SUBASSUNTO.concat(
            filtro
          ),
          docs => {
            utilHttp.httpGet(
              api.BUSCAR_PROTOCOLO_SOLICITACAO_DOCUMENTO.concat('/').concat(
                self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.id
              ),
              protocoloSolicitacaoDocs => {
                self.protocoloSolicitacaoDocs = protocoloSolicitacaoDocs.body

                docs.body.forEach(docs => {
                  var item = self.protocoloSolicitacaoDocs.filter(
                    p =>
                      p.documentacaoNecessaria.documento.codDocumento ===
                      docs.documento.codDocumento
                  )
                  if (item.length > 0) {
                    docs.documento.indSelecionado = 'S'
                    self.documentoToggle.push(docs)
                  } else {
                    docs.documento.indSelecionado = 'N'
                    // self.documentoToggle.push(docs)
                  }
                })
                self.dadosDocumentoNecessarioArray = docs.body
              }
            )
          }
        )
        return resolve(true)
      })
    },
    async carregaGrid () {
      var self = this
      return new Promise(resolve => {
        if (self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.numSolicitacao) {
          var filtro = ''
            .concat('?id=').concat(self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.id)
          utilHttp.httpGet(api.PROTOCOLO_SOLICITACAO_MOVIMENTACAO_DOCUMENTOS.concat(filtro), resposta => {
            var protocoloSolicitacaoMovimentacaoLista = resposta.body
            self.protocoloSolicitacaoMovimentacaoArrayBkp = JSON.parse(JSON.stringify(protocoloSolicitacaoMovimentacaoLista))
            this.$refs['refSolicitacaoMovimentacaoDocumentos'].inicializar(protocoloSolicitacaoMovimentacaoLista)
            return resolve(true)
          })
        }
      })
    },
    async carregarSelects () {
      return new Promise(resolve => {
        var self = this
        self.sexoArray = [
          { indSexo: 'M', descricao: 'Masculino' },
          { indSexo: 'F', descricao: 'Feminino' },
          { indSexo: 'I', descricao: 'Indiferente' }
        ]
        self.retornoArray = [
          { indRetorno: 'SEL', descricao: 'Selecione' },
          { indRetorno: 'APV', descricao: 'Aprovar' },
          { indRetorno: 'PDC', descricao: 'Retornar Pendências' },
          { indRetorno: 'REJ', descricao: 'Rejeitar' }
        ]
        self.estadoCivilArray = [
          { indEstadoCivil: 'S', descricao: 'Solteiro' },
          { indEstadoCivil: 'C', descricao: 'Casado' },
          { indEstadoCivil: 'N', descricao: 'Separado' },
          { indEstadoCivil: 'D', descricao: 'Divorciado' },
          { indEstadoCivil: 'V', descricao: 'Viúvo' }
        ]
        utilHttp.httpGet(self.apiUf, resposta => {
          var listaUfs = []
          listaUfs = resposta.body
          listaUfs.forEach(uf => {
            self.ufArray.push({
              codigo: uf.codUf,
              descricao: uf.nomUf
            })
          })
          return resolve(listaUfs)
        })
      })
    },
    async buscarDadosAbertura () {
      var self = this
      return new Promise(resolve => {
        var aberturaProcesso = {}
        var filtro = ''
          .concat('?numProtocolo=')
          .concat(self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.numProtocolo)
        utilHttp.httpGet(api.ABERTURA_PROCESSO_NUM_PROTOCOLO.concat(filtro), resposta => {
          aberturaProcesso = resposta.body
          if (aberturaProcesso) {
            self.paginaStatus.aberturaProcesso = aberturaProcesso
            if (self.paginaStatus.aberturaProcesso.justificativa) {
              setTimeout(() => {
                self.$refs['refJustificativa'].carregar(self.paginaStatus.aberturaProcesso.justificativa.codJustificativa, self.paginaStatus.aberturaProcesso.justificativa.desJustificativa)
              }, 100)
            }
          }
        })
        return resolve(true)
      })
    },
    async carregaAoEditar (a, item) {
      var self = this
      return new Promise(resolve => {
        if (self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.tipoProcesso) {
          self.codTipoProcesso = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.tipoProcesso.codTipoProcesso
          self.$refs['refTipoProcesso'].carregar(self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.tipoProcesso.codTipoProcesso, self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.tipoProcesso.desTipoProcesso)
        }
        if (self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.assuntoGeral) {
          self.codAssunto = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.assuntoGeral.codAssunto
          self.$refs['refAssunto'].carregar(self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.assuntoGeral.codAssunto, self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.assuntoGeral.desAssunto)
        }
        if (self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.subassunto) {
          self.codSubassunto = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.subassunto.codSubassunto
          self.$refs['refSubAssunto'].carregar(self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.subassunto.codSubassunto, self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.subassunto.desSubassunto)
        }
        if (self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.justificativa) {
          self.$refs['refJustificativa'].carregar(self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.justificativa.codJustificativa, self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.justificativa.desJustificativa)
        }
        return resolve(true)
      })
    },
    async buscarParametrosSistema () {
      var self = this
      return new Promise(resolve => {
        utilHttp.httpGet(api.PARAMETROS_SISTEMA, resposta => {
          if (resposta.body !== undefined && resposta.body !== '') {
            self.parametrosSistema = resposta.body
            self.formaSolicitacaoWeb = self.parametrosSistema.formaSolicitacao.codFormaSolicitacao
          } else {
            self.formaSolicitacaoWeb = 0
          }
        })
        return resolve(true)
      })
    },
    async marcarNotificacaoComoLida () {
      return new Promise(resolve => {
        let url = this.apiNotificacaoLida
        url = url.concat('?codProtocoloSolicitacao=').concat(this.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.id)
        url = url.concat('&codUsuario=').concat(this.$login.getCodUsuario())
        utilHttp.httpGet(url, resposta => { })
        return resolve(true)
      })
    },
    async forceFileDownload (response, item) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url

      link.setAttribute('download', item.servidorArquivo.nomeArquivo)
      document.body.appendChild(link)
      link.click()
    },
    imprimirComprovanteEncaminhamento () {
      var self = this
      let url = ''
      url = self.apiImprimirRelatorio.concat('?codProcesso=').concat(self.paginaStatus.aberturaProcesso.codProcesso.toString())
      url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
      url = url.concat('&nomComprovanteEncaminhamento=').concat(self.parametrosSistema.nomComprovanteEncaminhamento)
      window.open(url)
    },
    imprimirComprovanteEncaminhamentoAposSalva (item) {
      var self = this
      let url = ''
      url = self.apiImprimirRelatorio.concat('?codProcesso=').concat(item.toString())
      url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
      url = url.concat('&nomComprovanteEncaminhamento=').concat(self.parametrosSistema.nomComprovanteEncaminhamento)
      window.open(url)
    },
    buscarDocumentoNecessario (objeto) {
      var self = this
      var filtro = ''
        .concat('?codTipoProcesso=')
        .concat(util.validarCampo(self.codTipoProcesso) ? self.codTipoProcesso : 0)
        .concat('&codAssunto=')
        .concat(self.codAssunto)
        .concat('&codSubassunto=')
        .concat(self.codSubassunto)

      utilHttp.httpGet(
        api.DOCUMENTACAO_NECESSARIA_TIPO_PROCESSO_E_ASSUNTO_SUBASSUNTO.concat(
          filtro
        ),
        resposta => {
          self.dadosDocumentoNecessarioArray = resposta.body
        }
      )
    },
    tipodedocumento () {
      var tipodedocumento = ''
      if (this.indTipoPessoa === 'J') {
        tipodedocumento = 'CNPJ'
      } else {
        tipodedocumento = 'CPF'
      }
      return tipodedocumento
    },
    dataAtual () {
      let dNow = new Date()
      return util.criarData(dNow)
    },
    habilitarConfirmarArquivo (item) {
      if (item.indAprovada === 'S') {
        return false
      } else {
        return true
      }
    },
    downloadWithVueResource (item) {
      this.$http({
        method: 'get',
        url: this.apiDownloadArquivo.concat('/').concat(item.servidorArquivo.codArquivo),
        responseType: 'arraybuffer',
        headers: utilHttp.getCabecalhoAutorizacao().headers
      })
        .then(response => {
          this.forceFileDownload(response, item)
        })
        .catch(() => console.error('Erro ao baixar arquivo'))
    },
    baixarAnexo (item) {
      var self = this
      var url = self.apiDownloadArquivos.concat('/').concat(item.servidorArquivo.codArquivo)
      utilHttp.httpGet(url, resposta => {
        location.href = url
      })
    },
    confirmarArquivo (item) {
      util.exibirConfirmacao('CONFIRMAÇÃO', msg.m(29), 'SIM, CONFIRMAR', 'NÃO', () => {
        var filtro = '/'.concat(item.id)
        item.indAprovada = 'S'
        this.paginaStatus.protocoloSolicitacaoMovimentacao.indAprovada = item.indAprovada
        utilHttp.httpPutCarregando(api.PROTOCOLO_SOLICITACAO_MOVIMENTACAO.concat(filtro), item, resposta => {
          util.exibirToastSucesso(msg.m(30))
        })
      })
    },
    salvar () {
      var self = this
      if (self.paginaStatus.operacao.descricao === 'Gerenciar Solicitação de Abertura') {
        if (self.validarComponentes()) {
          if (util.validarComponentes(this.$refs)) {
            self.visualizarSalvar = false
            util.mostrarCarregando()
            var protocoloSolicitacaoMovimentacaoVisao = {
              protocoloSolicitacao: {},
              protocoloSolicitacaoDocumentosList: [],
              protocoloSolicitacaoMovimentacao: {},
              aberturaProcessoVisao: {
                aberturaProcesso: {},
                aberturaProcessoDocumentosList: [],
                movimentacaoProcesso: {}
              }
            }
            self.documentoToggle.forEach(doc => {
              var protocoloSolicitacaoDocumento = {
                codUsuario: self.$login.getCodUsuario(),
                documentacaoNecessaria: doc
              }
              protocoloSolicitacaoMovimentacaoVisao.protocoloSolicitacaoDocumentosList.push(protocoloSolicitacaoDocumento)
            })
            protocoloSolicitacaoMovimentacaoVisao.protocoloSolicitacaoMovimentacao = self.paginaStatus.protocoloSolicitacaoMovimentacao
            protocoloSolicitacaoMovimentacaoVisao.protocoloSolicitacao = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao
            if (self.indRetorno === 'APV') {
              self.paginaStatus.aberturaProcesso.codUsuario = self.$login.getCodUsuario()
              self.paginaStatus.aberturaProcesso.datProcesso = new Date()
              self.paginaStatus.aberturaProcesso.horProcesso = ''
                .concat(self.paginaStatus.aberturaProcesso.datProcesso.getHours())
                .concat(':')
                .concat(self.paginaStatus.aberturaProcesso.datProcesso.getMinutes())
                .concat(':')
                .concat(self.paginaStatus.aberturaProcesso.datProcesso.getSeconds())
              self.paginaStatus.aberturaProcesso.datAtualizacao = new Date()
              self.paginaStatus.aberturaProcesso.anoProcesso = self.paginaStatus.aberturaProcesso.datProcesso.getFullYear()

              self.paginaStatus.aberturaProcesso.formaSolicitacao.codFormaSolicitacao = self.formaSolicitacaoWeb
              self.paginaStatus.aberturaProcesso.txtObservacao = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.txtJustificativa
              self.paginaStatus.aberturaProcesso.indLiberadoProtocolo = 'S'
              self.paginaStatus.aberturaProcesso.indStatusProcesso = 'ABE'
              self.paginaStatus.aberturaProcesso.indTipoEndereco = 'N'
              self.paginaStatus.aberturaProcesso.requerente = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.requerente
              self.paginaStatus.aberturaProcesso.subassunto = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.subassunto
              self.paginaStatus.aberturaProcesso.tipoProcesso = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.tipoProcesso
              if (util.validarObjeto(self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.usuarioPortalServico)) {
                self.paginaStatus.aberturaProcesso.txtEmail = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.usuarioPortalServico.usuarioPortal.txtEmail
              } else {
                self.paginaStatus.aberturaProcesso.txtEmail = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.requerente.txtEmail
              }
              protocoloSolicitacaoMovimentacaoVisao.aberturaProcessoVisao.aberturaProcesso = self.paginaStatus.aberturaProcesso

              self.documentoToggle.forEach(doc => {
                var aberturaProcessoDocumento = {
                  codUsuario: self.$login.getCodUsuario(),
                  documentacaoNecessaria: doc
                }
                protocoloSolicitacaoMovimentacaoVisao.aberturaProcessoVisao.aberturaProcessoDocumentosList.push(aberturaProcessoDocumento)
              })

              var movimentacaoProcesso = {
                numSequencia: 1,
                txtObservacaoMovimento: 'Abertura do Processo',
                indStatusProcesso: 'ABE',
                numSequenciaRota: self.paginaStatus.aberturaProcesso.roteiro.numSequencia,
                setor: self.paginaStatus.aberturaProcesso.roteiro.setor,
                setorConfirmacao: self.paginaStatus.aberturaProcesso.roteiro.setor,
                numSequenciaRotaAlternativa: 0,
                txtObeservacaoConfirmacao: 'Abertura do Processo',
                codUsuario: self.$login.getCodUsuario()
              }

              protocoloSolicitacaoMovimentacaoVisao.aberturaProcessoVisao.movimentacaoProcesso = movimentacaoProcesso
              protocoloSolicitacaoMovimentacaoVisao.protocoloSolicitacaoMovimentacao.txtObservacaoRetorno = 'Protocolo Aberto'
            }
            utilHttp.httpPost(api.PROTOCOLO_SOLICITACAO_MOVIMENTACAO, protocoloSolicitacaoMovimentacaoVisao, resposta => {
              if (resposta.status === 201) {
                if (resposta.body.codProcesso) this.imprimirComprovanteEncaminhamentoAposSalva(resposta.body.codProcesso)
                util.exibirToastSucesso(msg.m(2))
                let url = api.NOTIFICACAO_SOLICITACAO
                url = url.concat('?codProtocoloSolicitacao=').concat(this.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.id)
                url = url.concat('&codUsuario=').concat(this.$login.getCodUsuario())
                utilHttp.httpDeletePorID(url, resposta => { })
                util.esconderCarregando()
                util.retornarCaminhoMigalhaPaginaAnterior(this)
              } else {
                self.visualizarSalvar = !self.paginaStatus.desabilitarEdicao
                util.esconderCarregando()
                util.exibirToastFalha('Erro ao salvar Solicitação de Abertura')
              }
            })
          }
        }
      }
    },
    validarComponentes () {
      var self = this
      if (self.indRetorno === 'SEL') {
        util.exibirToastAviso('Retorno da Solicitação deve ser selecionado.')
        self.chamarRodape()
        return false
      }
      if (self.indRetorno === 'PDC' && !self.txtObservacaoRetorno) {
        util.exibirToastAviso('Pendência(s) deve(m) ser informada(s).')
        return false
      }
      if (self.indRetorno === 'REJ' && !self.txtObservacaoRetorno) {
        util.exibirToastAviso('Favor informar o motivo da Rejeição da Solicitação.')
        return false
      }

      if (self.indRetorno === 'APV') {
        if (!self.codTipoProcesso) {
          util.exibirToastAviso('Favor informar o Tipo de Processo.')
          self.chamarTopo()
          return false
        } else if (!self.codAssunto) {
          util.exibirToastAviso('Favor informar o Assunto.')
          self.chamarTopo()
          return false
        } else if (!self.codSubassunto) {
          util.exibirToastAviso('Favor informar o Subassunto.')
          self.chamarTopo()
          return false
        } else if (!self.paginaStatus.aberturaProcesso.justificativa.codJustificativa) {
          util.exibirToastAviso('Favor informar a justificativa do processo.')
          self.chamarTopo()
          return false
        } else if (!self.paginaStatus.aberturaProcesso.responsavel || !self.paginaStatus.aberturaProcesso.responsavel.codResponsavel) {
          util.exibirToastAviso('Você não é Responsável pelo Setor do Protocolo a ser aberto.')
          return false
        }
      }
      return true
    },
    getFiltroJustificativa () {
      var filtro = ''
      filtro = filtro
        .concat('/')
        .concat(util.validarCampo(this.codTipoProcesso) ? this.codTipoProcesso : 0)
        .concat('/')
        .concat(this.codAssunto)
        .concat('/')
        .concat(this.codSubassunto)
        .concat('/null')
      return filtro
    },
    buscarRotaPeloProcessoSubassunto (valor) {
      var self = this
      var filtro = ''
        .concat('?codTipoProcesso=')
        .concat(util.validarCampo(self.codTipoProcesso) ? self.codTipoProcesso : 0)
        .concat('&codAssunto=')
        .concat(self.codAssunto)
        .concat('&codSubassunto=')
        .concat(self.codSubassunto)
      self.atualizarVariaveis()
      utilHttp.httpGet(api.ROTEIRO_ASSUNTO.concat(filtro), resposta => {
        self.rotaArray = resposta.body
        if (self.rotaArray.length > 0 && self.paginaStatus.operacao.descricao === 'Gerenciar Solicitação de Abertura') {
          self.paginaStatus.aberturaProcesso.roteiro.numRota = self.rotaArray[0].numRota
          self.buscarDadosRoteiro()
          self.desabilitarJustificativa = false
        } else if (!self.paginaStatus.aberturaProcesso.roteiro) {
          self.paginaStatus.aberturaProcesso.roteiro = {}
        } else {
          if (util.validarCampo(self.codTipoProcesso) && valor && self.paginaStatus.operacao.descricao !== 'Visualizar Solicitação de Abertura') {
            util.exibirToastAviso('Não existe Roteiro do processo cadastrado para o [Tipo, Assunto e Subassunto] informado!')
          }
          self.paginaStatus.aberturaProcesso.roteiro.setor.codSetor = null
          self.paginaStatus.aberturaProcesso.roteiro.setor.unidade.codUnidade = null
          self.paginaStatus.aberturaProcesso.roteiro.setor.unidade.orgao.codOrgao = null
        }
      })
    },
    atualizarVariaveis () {
      var self = this
      self.txtJustificativa = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.txtJustificativa
      self.txtObservacao = self.paginaStatus.protocoloSolicitacaoMovimentacao.txtObservacao
      if (self.paginaStatus.operacao.descricao !== 'Gerenciar Solicitação de Abertura') {
        if (self.paginaStatus.protocoloSolicitacaoMovimentacao.status === 'Abertura Solicitada') {
          self.indRetorno = 'SEL'
        } else if (self.paginaStatus.protocoloSolicitacaoMovimentacao.status === 'Abertura Pendente') {
          self.indRetorno = 'PDC'
          self.txtObservacaoRetorno = self.paginaStatus.protocoloSolicitacaoMovimentacao.txtObservacaoRetorno
        } else if (self.paginaStatus.protocoloSolicitacaoMovimentacao.status === 'Aberto') {
          self.indRetorno = 'APV'
        } else if (self.paginaStatus.protocoloSolicitacaoMovimentacao.status === 'Rejeitado') {
          self.indRetorno = 'REJ'
          self.txtObservacaoRetorno = self.paginaStatus.protocoloSolicitacaoMovimentacao.txtObservacaoRetorno
        }
      }
      if (self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.requerente) {
        self.indTipoPessoa = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.requerente.indTipoPessoa
        if (self.indTipoPessoa !== 'J') {
          self.dataNascimento = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.requerente.dataNascimento
          self.indSexo = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.requerente.indSexo
          self.indEstadoCivil = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.requerente.indEstadoCivil
          if (self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.requerente.nacionalidade) {
            self.nomNacionalidade = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.requerente.nacionalidade.nomNacionalidade
          }
        } else {
          self.dataNascimento = ''
          self.indSexo = ''
          self.indEstadoCivil = ''
        }
        self.nomRequerente = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.requerente.nomRequerente
        self.txtDocumento = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.requerente.documentoFormatado
        self.numCEP = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.requerente.numCEP
        self.numNumero = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.requerente.numNumero
        self.txtComplemento = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.requerente.txtComplemento
        if (self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.requerente.uf) {
          self.codUf = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.requerente.uf.codUf
          self.desUf = this.ufArray.length > 0 ? this.ufArray.filter(x => x.codigo === this.codUf)[0].descricao : ''
        }
        self.numTelefoneMovel = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.requerente.numTelefoneMovel
        self.numTelefoneResidencial = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.requerente.numTelefoneResidencial
        self.numTelefoneComercial = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.requerente.numTelefoneComercial
        self.txtEmail = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.requerente.txtEmail

        if (util.validarObjeto(self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.usuarioPortalServico)) {
          self.txtEmailPortal = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.usuarioPortalServico.usuarioPortal.txtEmail
          self.numTelefoneMovelPortal = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.usuarioPortalServico.usuarioPortal.numTelefoneMovel
          self.numTelefoneResidencialPortal = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.usuarioPortalServico.usuarioPortal.numTelefoneResidencial
          self.numTelefoneComercialPortal = self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.usuarioPortalServico.usuarioPortal.numTelefoneComercial
        }
      }
    },
    buscarDadosRoteiro () {
      var self = this
      var filtro = ''
        .concat('?numRota=')
        .concat(self.paginaStatus.aberturaProcesso.roteiro.numRota)
        .concat('&codTipoProcesso=')
        .concat(util.validarCampo(self.codTipoProcesso) ? self.codTipoProcesso : 0)
        .concat('&codAssunto=')
        .concat(self.codAssunto)
        .concat('&codSubassunto=')
        .concat(self.codSubassunto)

      utilHttp.httpGet(api.ROTEIRO_SEQUENCIA.concat(filtro), resposta => {
        self.dadosRoteiroArray = resposta.body
        if (self.dadosRoteiroArray.length >= 0) {
          self.paginaStatus.aberturaProcesso.roteiro =
            self.dadosRoteiroArray[0]
          self.desabilitarJustificativa = false
        }
      })
    },
    buscarResponsavel () {
      var self = this
      var responsavelSetor = {}
      var filtro = ''
        .concat('?codUsuario=')
        .concat(self.$login.getCodUsuario())
        .concat('&codSetor=')
        .concat(self.paginaStatus.aberturaProcesso.roteiro.setor.codSetor)
        .concat('&codUnidade=')
        .concat(self.paginaStatus.aberturaProcesso.roteiro.setor.unidade.codUnidade)
        .concat('&codOrgao=')
        .concat(self.paginaStatus.aberturaProcesso.roteiro.setor.unidade.orgao.codOrgao)
        .concat('&indModulo=')
        .concat('PRO')

      util.mostrarCarregando()
      utilHttp.httpGet(api.RESPONSAVEL_SETOR_USUARIO_SETOR_UNIDADE_ORGAO.concat(filtro), resposta => {
        responsavelSetor = resposta.body

        if (responsavelSetor) {
          self.paginaStatus.aberturaProcesso.responsavel = responsavelSetor
        }
        util.esconderCarregando()
      })
    },
    getFiltroSubassunto () {
      return '/'.concat(this.codAssunto)
    },
    desabilitarCampos () {
    },
    habilitarCampos () {
    },
    carregamentoInicial () {
      var self = this
      iniciar()
      async function iniciar () {
        self.indTipoPessoa = 'F'
        self.indRetorno = 'SEL'
        let a = await self.carregarSelects()
        let b = await self.carregaAoEditar(a, self.paginaStatus.protocoloSolicitacaoMovimentacao)
        let c = await self.carregaGrid()
        let d = await self.buscarDocumentacaoApresentada()
        let e = await self.buscarParametrosSistema()
        let f = await self.marcarNotificacaoComoLida()
        if (a && b && c && d && e && f) {
          self.visualizarSalvar = !self.paginaStatus.desabilitarEdicao
          self.buscarRotaPeloProcessoSubassunto(true)
          self.desabilitarDadosRequerente = true
          if (self.paginaStatus.operacao.descricao !== 'Gerenciar Solicitação de Abertura') {
            self.imprimir = self.paginaStatus.protocoloSolicitacaoMovimentacao.status === 'Aberto'
            self.desabilitarTipoProcesso = true
            self.desabilitarAssunto = true
            self.desabilitarSubAssunto = true
            self.desabilitarRetorno = true
            self.readonly = true
            self.desabilitarDocumentos = true
            self.desabilitarJustificativa = true
            if (self.indRetorno === 'APV') {
              await self.buscarDadosAbertura()
            }
          }
          if (self.paginaStatus.protocoloSolicitacaoMovimentacao.status === 'Aberto') {
            // Marcar Retorno como aberto
            setTimeout(() => { this.indRetorno = 'APV' }, 100)
          }
        }
      }
    },
    chamarTopo () {
      window.scroll({ top: 0, behavior: 'smooth' })
    },
    chamarRodape () {
      window.scroll({ top: document.body.scrollHeight, behavior: 'smooth' })
    },
    formatarData (data, formato) {
      return util.formatarData(data, formato)
    },
    formataEstadoCivil (estadoCivil) {
      switch (estadoCivil) {
        case 'S': return 'Solteiro'
        case 'C': return 'Casado'
        case 'N': return 'Separado'
        case 'D': return 'Divorciado'
        case 'V': return 'Viúvo'
        default:
          return ''
      }
    }
  },
  watch: {
    paginaStatus: {
      handler (valor) {
        if (valor) {
          util.adicionarNoStorage(this.chaveLocalStorage, valor)
        } else util.removerDoStorage(this.chaveLocalStorage)
      },
      deep: true
    },
    codTipoProcesso: {
      handler (valor) {
        var self = this
        if (self.codTipoProcesso !== undefined && self.codTipoProcesso !== '') {
          if (self.$refs['refTipoProcesso'].objetoSelecionado.codTipoProcesso) self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.tipoProcesso = self.$refs['refTipoProcesso'].objetoSelecionado
        } else {
          if (self.paginaStatus.aberturaProcesso.justificativa.codJustificativa !== undefined && self.paginaStatus.aberturaProcesso.justificativa.codJustificativa !== '') {
            self.$refs['refJustificativa'].limpar()
          }
        }
        self.documentoToggle = []
        self.buscarRotaPeloProcessoSubassunto(false)
        self.buscarDocumentoNecessario()
        self.indRetorno = 'SEL'
      }
    },
    codAssunto: {
      handler (valor) {
        var self = this
        if (self.codAssunto !== undefined && self.codAssunto !== '') {
          if (self.$refs['refAssunto'].objetoSelecionado.codAssunto) self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.assuntoGeral = self.$refs['refAssunto'].objetoSelecionado
          self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.assuntoGeral.codAssunto = self.codAssunto
        } else {
          if (self.codSubassunto !== undefined && self.codSubassunto !== '') {
            self.$refs['refSubAssunto'].limpar()
          }
          if (self.paginaStatus.aberturaProcesso.justificativa.codJustificativa !== undefined && self.paginaStatus.aberturaProcesso.justificativa.codJustificativa !== '') {
            self.$refs['refJustificativa'].limpar()
          }
        }
        self.buscarRotaPeloProcessoSubassunto(false)
        self.buscarDocumentoNecessario()
        self.indRetorno = 'SEL'
      }
    },
    codSubassunto: {
      handler (valor) {
        var self = this

        if (self.codSubassunto !== undefined && self.codSubassunto !== '') {
          if (self.$refs['refSubAssunto'].objetoSelecionado.codSubassunto) self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.subassunto = self.$refs['refSubAssunto'].objetoSelecionado
          self.paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.subassunto.codSubassunto = self.codSubassunto
        } else {
          if (self.paginaStatus.aberturaProcesso.justificativa.codJustificativa !== undefined && self.paginaStatus.aberturaProcesso.justificativa.codJustificativa !== '') {
            self.$refs['refJustificativa'].limpar()
          }
        }
        self.documentoToggle = []
        if (self.paginaStatus.operacao.descricao === 'Visualizar') self.desabilitarJustificativa = false
        self.buscarRotaPeloProcessoSubassunto(true)
        self.buscarDocumentoNecessario()
        self.indRetorno = 'SEL'
      }
    },
    indRetorno: {
      handler (valor) {
        var self = this
        self.desabilitarRejeicao = true
        self.desabilitarPendencia = true
        self.desPendencia = ''
        self.desRejeicao = ''
        if (valor === 'PDC') {
          self.paginaStatus.protocoloSolicitacaoMovimentacao.status = 'Abertura Pendente'
          self.desabilitarPendencia = false
        } else if (valor === 'REJ') {
          self.paginaStatus.protocoloSolicitacaoMovimentacao.status = 'Rejeitado'
          self.desabilitarRejeicao = false
        } else if (valor === 'APV') {
          self.paginaStatus.protocoloSolicitacaoMovimentacao.status = 'Aberto'
          self.desabilitarRejeicao = false
          if (self.paginaStatus.aberturaProcesso.roteiro.setor.codSetor !== undefined &&
            self.paginaStatus.aberturaProcesso.roteiro.setor.codSetor !== null &&
            self.paginaStatus.aberturaProcesso.roteiro.setor.codSetor !== '' &&
            self.paginaStatus.aberturaProcesso.roteiro.setor.unidade.codUnidade !== undefined &&
            self.paginaStatus.aberturaProcesso.roteiro.setor.unidade.codUnidade !== null &&
            self.paginaStatus.aberturaProcesso.roteiro.setor.unidade.codUnidade !== '' &&
            self.paginaStatus.aberturaProcesso.roteiro.setor.unidade.orgao.codOrgao !== undefined &&
            self.paginaStatus.aberturaProcesso.roteiro.setor.unidade.orgao.codOrgao !== null &&
            self.paginaStatus.aberturaProcesso.roteiro.setor.unidade.orgao.codOrgao !== '') {
            self.buscarResponsavel()
          } else if (!self.paginaStatus.aberturaProcesso.responsavel) {
            self.paginaStatus.aberturaProcesso.responsavel = {}
          } else {
            self.paginaStatus.aberturaProcesso.responsavel.codResponsavel = null
          }
        }
        self.paginaStatus.protocoloSolicitacaoMovimentacao.indRetorno = self.indRetorno
      }
    },
    txtObservacaoRetorno: {
      handler (valor) {
        var self = this
        self.paginaStatus.protocoloSolicitacaoMovimentacao.txtObservacaoRetorno = self.txtObservacaoRetorno
      }
    },
    indTipoPessoa: {
      handler (valor) {
        var self = this
        if (valor === 'J' && self.$refs['refTxtDocumento']) {
          self.$refs['refTxtDocumento'].dTamanho = 18
        } else if (valor === 'F' && self.$refs['refTxtDocumento']) {
          self.$refs['refTxtDocumento'].dTamanho = 14
        }
      }
    }
  },
  mounted () {
    var self = this
    if (self.$route.params.paginaStatus) {
      self.paginaStatus = self.$route.params.paginaStatus
      self.paginaStatus.caminhoMigalha.push({
        icone: self.paginaStatus.operacao.icone,
        descricao: self.paginaStatus.operacao.descricao,
        rotaNome: 'solicitacaoAbertura'
      })
    } else if (util.recuperarDoStorage(self.chaveLocalStorage)) {
      self.paginaStatus = util.recuperarDoStorage(self.chaveLocalStorage)
    }
    self.carregamentoInicial()
  },
  components: { GBreadcrumb, GAutocomplete, GInput, GGridview, GSelect, GDatepicker, GDatatable }
}
</script>
